import { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import './HalfPageBreif.css'
// import { Globals } from '../../global/Globals';
import { fetchHalfPageBreif } from '../../services/api';
import { dateFunct, formatDate } from '../../util/util';
import { useNavigate } from 'react-router-dom';
import NoResultsComponent from '../../components/NoResults/NoResult';
import Loader from '../../components/Loader/Loader';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

export default function HalfPageBreif({additionalData,togglePopup}) {
  const { Globals ,languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const [BreifData, setBreifData] = useState([])
  const [contentData, setContentData] = useState([])
  const [contentDataStatus, setContentDataStatus] = useState(null)
  const [data, setData] = useState([]);
  const { proposalId } = additionalData;
   const multiLang = localStorage.getItem("lang");

  const getData = async () => {
    try {
      const result = await fetchHalfPageBreif(
        Globals.ENDPOINT.HALFPAGE_BRIEF,
        proposalId
      );

      const {
        countryName,
        productionTypeName,
        channelName,
        formatName,
        languageName,
        genreName,
        contentTypeName,
        clusterName,
        description,
        submissionRequirements,
        evalAndSelection,
        closingDate
      } = result.content;
      setContentData([
        { Description: description },
        { "Submission Requirements": submissionRequirements },
        { "Evaluation Process": evalAndSelection || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
      ]);
      setBreifData([
        { name: "Channel", description: channelName },
        { name: "Format", description: formatName },
        { name: "Country", description: countryName },
        { name: "Production Type", description: productionTypeName },
        { name: "Scripted / Non-Scripted", description: contentTypeName },
        { name: "Genre", description: genreName },
        { name: "Language", description: languageName },
        { name: "Cluster", description: clusterName },
        {name: "Closing Date",description: closingDate ? formatDate(closingDate):Globals.HALF_PAGE_BRIEF_DETAILS.NA}
      ])
      setData([result?.content]);

    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
      console.error('Error in App component:', error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleReload = () => {
    setContentDataStatus(null)
    getData();
  }

  return (
    <div>
        <div className="Half-Page-Content">
          <div className="Half-Page-Header-Wrapper">
          {data && data?.length >0 &&
           <div className='Half-page-breif-header'>{`${data?.[0]?.bRefNo}/ ${data?.[0]?.channelName} ${data?.[0]?.countryName} - ${data?.[0]?.formatName}`}</div>
          }
            <span className="HalfPage-close-icon HalfPage-close-icon-brief" onClick={togglePopup}>
              &times;
            </span>

          </div>
          {data && data?.length >0  ?<>
            <div className='intenalhalf-page-brief'>
            <div className="HalfPage-pitch">
            <div className="HalfPage-titleWrapper">
              <div className="HalfPage-header">{`${data?.[0]?.channelName} ${data?.[0]?.countryName} - ${data?.[0]?.formatName}`}</div>
              <div className="HalfPage-Date-Wrapper">
              <p className="HalfPage-date-item1">{Globals.CLOSING_DATE}</p>
              <p className="HalfPage-date-item2">{dateFunct(data[0].closingDate)}</p>
            </div>
            </div>
            {}
            {contentData?.map(
              (item, index) =>
                Object.values(item)[0] && (
                  <div key={index} className="Half-Page-Content-Wrapper">
                    <div className={`${Object.keys(item)[0]==='Description'?'description-heading':'small-heading'} Half-Page-Desc-header`}>
                      {Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                    </div>
                    <p className="Half-Page-Description">
                      {Object.values(item)[0]}
                    </p>
                  </div>
                )
            )}
            <div>
              <div className="Half-Page-Form">
                {BreifData?.map((item, index) => (
                  <div key={index} className="Half-Page-Form-Fields">
                    <div className="Half-Page-Form-fields-Bold">
                      {Globals.BRIEF_DATA_KEYS[`${item.name.toUpperCase()}`]}
                    </div>
                    <div className="Half-Page-Form-Description">
                      {item.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          </div>
          <div className="Half-Page-Close-Apply-Wrapper">
            <div className="Half-Page-Close-Apply-Brief">
              <div className="Half-Page-Close-Text-Brief" onClick={togglePopup}>
                {Globals.CLOSE}
              </div>
              <Button
                title={Globals.APPLY_BRIEF.APPLY_BUTTON}
                id="Half-Screen-Apply-Button"
                additionalStyle={`apply-button appy-${multiLang}`}
                action={()=>navigate(Globals.NAVPATH.APPLY_BRIEF, { state: { activeData: data }})}
              />
            </div>
          </div>
          </>:contentDataStatus && contentDataStatus?.length > 0 ? <>
          <div className = "No-Results-Wrapper"><NoResultsComponent
                          data={{
                            message: Globals.HALF_PAGE_MESSAGE,
                            img: Globals.IMG.HALF_PAGE_ERROR,
                            submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                            className:"ErrorHeader",
                            subclassName:"SubError",
                            outerWrapper:"HalfPageWrapperHalfPageBrief",
                            imgWrapper:"HalfPageBriefImg",
                            button:'reload'
                          }}
                          handleReload = {handleReload}
                        />
          </div>
          <div className="Half-Page-Close-Apply-Wrapper">
            <div className="Half-Page-Close-Apply-Brief">
              <div className="Half-Page-Close-Text-Brief" onClick={togglePopup}>
                {Globals.CLOSE}
              </div>
            </div>
          </div>
          </>:<div className="NoResultsComponent" style={{height:"80vh"}}>
          <Loader height={50} width={50} />
          </div>}

        </div>
    </div>
  );
}